import deleteApiCall from './delete';
import detailApiCall from './detail';
import listApiCall from './list';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  delete: deleteApiCall,
};

export default ApiCall;
